import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CustomDomainEnabledContentType = '' as const;
export type CustomDomainEnabledRequest = void;
export type CustomDomainEnabledResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': boolean;
    };
};
export type CustomDomainEnabledResponseSuccess = CustomDomainEnabledResponses['200']['application/json'];
export type CustomDomainEnabledSearchParams = undefined;
export type CustomDomainEnabledPathParameters = undefined;
export const CustomDomainEnabledUrl = '/email/custom_domain_enabled' as const;
export const CustomDomainEnabledMethod = 'GET' as const;
export const getCustomDomainEnabledUrl = (_params?: CustomDomainEnabledPathParameters) => CustomDomainEnabledUrl;
